import { Page } from '@internal/backstage-plugin-hm-react';
import { Link } from '@backstage/ui';
import { Entity } from '@backstage/catalog-model';
import { ScaffolderPage } from './scaffolder-page';

export const ScaffolderLandingPage = () => {
  const groups = [
    {
      title: 'Create a New Project with Threads Templates (machx)',
      description: (
        <>
          Start your journey to create the next sustainable, secure and cost
          conscious software product at H&M. Learn more on{' '}
          <Link href="/docs/default/system/machx">machx documentation</Link>
        </>
      ),
      filter: (entity: Entity) =>
        entity?.metadata?.tags?.includes('machx') ?? false,
    },
    {
      title: 'Self-Service Data Platform on GCP',
      description: (
        <>
          Provision standardized, governed and production-ready data platform
          components on Google Cloud. Learn more about the{' '}
          <Link href="/docs/default/component/gcp-dataplatform-doc">
            GCP Data Platform
          </Link>
        </>
      ),
      filter: (entity: Entity) =>
        entity?.metadata?.tags?.includes('gcp-data-platform') ?? false,
    },
  ];

  return (
    <Page title="Templates">
      <ScaffolderPage groups={groups} />
    </Page>
  );
};
